import MUIDrawer from '@material-ui/core/Drawer';
import React from 'react';

import styled from 'styled-components';

const StyledDrawer = styled(MUIDrawer)`
    & .drawer-paper {
       width: 17.25em;
    },
    
    & .schnoffle-drawer-logo {
      padding: 0.5em 0 0 1.25em;
      height: 3em;
    }
`;

const Drawer = ({ Menu, open, toggleMenu }) => (
        <StyledDrawer
            anchor={'left'}
            open={open}
            onClose={toggleMenu}
            classes={{
                paper: 'drawer-paper',
            }}
            ModalProps={{
                keepMounted: true, // Better open performance on
                                           // mobile.
            }}
        >
            {Menu}
        </StyledDrawer>
    );

export default Drawer;



// WEBPACK FOOTER //
// ./src/components/header/Drawer.js